module.exports = __webpack_public_path__ + "img/main.c182010c.png";